module.exports = __webpack_public_path__ + "f8cfd5853caef09e7171d0950729c054.pdf";